import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoltLightning, faFaceSmileBeam } from '@fortawesome/sharp-regular-svg-icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import MoodTracker from './MoodTracker';
import StressTracker from './StressTracker';

function StressNMoodTracker(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openStress, setOpenStress] = useState(false);
  const [openMood, setOpenMood] = useState(false);

  const handleStress = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenStress(true);
    }, 500);
  };

  const handleMood = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenMood(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openStress) {
      const stress = document.getElementById('snm-stress');
      setTimeout(() => {
        stress?.classList.add('slide-in');
      }, 300);
    }
  }, [openStress]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  useEffect(() => {
    if (openMood) {
      const mood = document.getElementById('snm-mood');
      setTimeout(() => {
        mood?.classList.add('slide-in');
      }, 300);
    }
  }, [openMood]);

  const handleBackToMain = () => {
    if (openStress) {
      const stress = document.getElementById('snm-stress');
      stress?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenStress(false);
        setAreaPicker(true);
      }, 500);
    }

    if (openMood) {
      const mood = document.getElementById('snm-mood');
      mood?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenMood(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleStress}
              type="button"
              aria-label={t('T183')}
            >
              <div>
                <FontAwesomeIcon icon={faBoltLightning} className="mood-icon" /> {t('T183')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
            <button className="mood-area" onClick={handleMood} type="button" aria-label={t('T184')}>
              <div>
                <FontAwesomeIcon icon={faFaceSmileBeam} className="mood-icon" /> {t('T184')}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openStress && (
        <StressTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
      {openMood && (
        <MoodTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default StressNMoodTracker;
